import { useFragmentFromStore } from '@smx-ui-model/hooks/use-fragment-from-store';
import { getModel } from '@smx-ui-model/store-model';
import { GenericModelSchemaType, StoreModelType } from '@smx-ui-model/types';
import { Form } from 'antd';
import { memo, useEffect, useState } from 'react';

interface EntityTableRowProps<C> {
    modelName: keyof StoreModelType;
    node?: any;
    contextName?: C;
}

export const EntityTableLoaderForm = memo(<C,>({ modelName, node, contextName }: EntityTableRowProps<C>) => {
    const form = Form.useFormInstance();
    const model = getModel<GenericModelSchemaType>(modelName);
    const dataEntity = useFragmentFromStore<any>(node);
    const values = Form.useWatch([], { form, preserve: true });
    const [render, setRender] = useState<number>(0);

    const listColumnName = contextName ? model.context?.[contextName] || [] : model.schema.context.table;

    useEffect(() => {
        if (render > 0) {
            listColumnName.forEach((columnName) => {
                const field = (model.schema.field as any)[columnName];

                form.setFieldsValue({
                    [dataEntity.id]: {
                        [field.name]: values?.[dataEntity.id]?.[field.name] || dataEntity[field.name],
                    },
                });
            });
        }
    }, [render]);

    useEffect(() => {
        if (!values) {
            setRender(render + 1);
        }
    }, []);

    return null;
});
